// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"094106dc","453":"34bc8f3b","623":"26bc0ae0"}[chunkId] + ".chunk.js";
};